import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";

/** Supplementary hint on hover and keyboard focus. Never the only place for essential info. */
export function Tooltip({ content, children }: { content: ReactNode; children: ReactNode }) {
  return (
    <TooltipPrimitive.Provider delayDuration={300}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            sideOffset={6}
            className="z-toast max-w-xs rounded-md bg-secondary px-3 py-2 text-sm text-secondary-fg shadow-elevated data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0"
          >
            {content}
            <TooltipPrimitive.Arrow className="fill-secondary" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
